var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M16 4c3.183 0 6.235 1.264 8.485 3.515C26.735 9.765 28 12.817 28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm0 1.5C10.203 5.506 5.506 10.203 5.5 16c0 5.799 4.701 10.5 10.5 10.5S26.5 21.799 26.5 16 21.799 5.5 16 5.5zm5.77 6.3c.287.295.287.765 0 1.06L13.9 20.2c-.14.128-.321.2-.51.2-.2 0-.39-.078-.53-.22l-2.61-2.61c-.2-.187-.283-.469-.215-.734.067-.266.275-.474.54-.541.266-.068.548.014.735.215l2.1 2.1 7.3-6.81c.293-.292.767-.292 1.06 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0 0H32V32H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#3B3B3B",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#007A39",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccessIcon);
export default __webpack_public_path__ + "static/media/notification-success-icon.b3b1d87c7b0a01784b1254dd0a53e020.svg";
export { ForwardRef as ReactComponent };